angular.module('unica_location.location_controllers')

.controller('LocationEditController', function(
	$rootScope, $scope, $state, $stateParams,
	LocationEditService
) {

	$scope.pageTitle = 'Modifica Location';

	$scope.getLocation( $stateParams.id );

	$scope._saveLocation = function() {
		LocationEditService
			.update( $scope.locationData )
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.showSuccessMsg('Location aggiornata con successo!', '');
				} else { 
					$rootScope.manageError(data);
				}
			});
	};

	$scope.saveLocation = function () {
		$scope.showLoader();

		if ( $scope.locationData.is_virtual ) {
			$scope._saveLocation();
		} else {
			$scope.geocoder.geocode({
				address: $scope.locationData.address
			}, function(responses) {
				if (responses && responses.length > 0) {
					$scope.locationData.zoom      = $scope.map.zoom;
					$scope.locationData.latitude  = responses[0].geometry.location.lat();
					$scope.locationData.longitude = responses[0].geometry.location.lng();
					$scope._saveLocation();
				}
			});
		}
	};


})

;